import request from './request'

export const addCategory = data => {
    return request({
        url: '/pedigree/saveCategory',
        method: 'POST',
        data
    })
}
export const removeCategory = id => {
    return request({
        url: '/pedigree/removeCategory',
        method: 'POST',
        data: { id: id }
    })
}

export const getCategoryList = () => {
    return request({
        url: '/pedigree/getCategoryList',
        method: 'POST'
    })
}
export const addPedigree = data => {
    return request({
        url: '/pedigree/savePedigree',
        method: 'POST',
        data
    })
}
export const getPedigreeList = () => {
    return request({
        url: '/pedigree/getPedigreeList',
        method: 'POST'
    })
}
export const removePedigree = id => {
    return request({
        url: '/pedigree/removePedigree',
        method: 'POST',
        data: { id: id }
    })
}
